'use strict';

var $ = require('jquery');
require('slick-carousel');

var startSlickslider = function($container,settings) {

	var $mainImage = $container.findByBem('slickslider','main-images__first');
	var $nextImage = $container.findByBem('slickslider','main-images__second');
	var $slider = $container.find('.slickslider__thumbnails');
	var $caption = $container.find('.slickslider__image-caption');
	var $fullScreenGalleryLink = $mainImage.parent();

	$(window).load(function(){
		$mainImage.parent().css({
			'height' : $mainImage.outerHeight() + 'px'
		});

		$(window).on('resize', function () {
			$mainImage.parent().css({
				'height' : $mainImage.outerHeight() + 'px'
			});
		});
	});

	$slider.slick(settings);

	$slider.find($('.gallery-slickslider:not(.gallery-slickslider--article-list) .slick-slide a').each(function(){
		$(this).click(function(e){

			e.preventDefault();

			$mainImage.attr('src',$(this).attr('href'));
			$nextImage.attr('src',$(this).attr('href'));

			if ($(this).attr('data-caption')) {
				if ($(this).attr('data-caption').length > 0) {
					$caption.fadeIn();
					if ($container.hasClass('gallery-slickslider--landing-page')) {
						$caption.html('<h2>' + $(this).attr('data-title') + '</h2><p>' + $(this).attr('data-caption') + '</p>');
					} else {
						$caption.text($(this).attr('data-caption'));
					}
				} else {
					$caption.fadeOut();
				}
			} else {
				$caption.fadeOut();
			}

			$fullScreenGalleryLink.attr('data-link',$(this).parent().attr('data-slick-index'));

			$slider.slick('slickGoTo',parseInt($(this).parent().attr('data-slick-index')),true);
			$(this).parent().addClass('slick-current').siblings().removeClass('slick-current');

			// Update href to story in main image link for landing page gallery
			if ($container.hasClass('gallery-slickslider--landing-page')) {
				$fullScreenGalleryLink.attr('href',$('.slick-current.slick-active > a').attr('data-url'));
			}

		});
	}));

	$slider.on('afterChange', function() {

		$nextImage.attr('src',$('.slick-current a').attr('href'));

		$mainImage.fadeOut(300, function() {

			$mainImage.attr('src',$('.slick-current a').attr('href'));

			if ($('.slick-current a').attr('data-caption')) {
				if ($('.slick-current a').attr('data-caption').length > 0) {
					$caption.fadeIn();
					if ($container.hasClass('gallery-slickslider--landing-page')) {
						$caption.html('<h2>' + $('.slick-current a').attr('data-title') + '</h2><p>' + $('.slick-current a').attr('data-caption') + '</p>');
					} else {
						$caption.text($('.slick-current a').attr('data-caption'));
					}
				} else {
					$caption.fadeOut();
				}
			} else {
				$caption.fadeOut();
			}
		}).fadeIn(300);

		$fullScreenGalleryLink.attr('data-link',$('.slick-current.slick-active').attr('data-slick-index'));

		// Update href to story in main image link for landing page gallery
		if ($container.hasClass('gallery-slickslider--landing-page')) {
			$fullScreenGalleryLink.attr('href',$('.slick-current.slick-active > a').attr('data-url'));
		}

	});
};

module.exports = {
	init: function ($container,settings) {
		startSlickslider($container,settings);
	}
};